import { TOGGLE_LOADING } from '@/store/mutation-types'

export default {
  [TOGGLE_LOADING] (state, loadingName) {
    const loading = `${ loadingName }Loading`
    state[loading] = !state[loading]
  }
}



// WEBPACK FOOTER //
// ./src/store/toggleLoading.js